<template>
  <div>
    <b-row>
      <b-col md="12" xl="12">
        <b-card
          :style="{
            backgroundImage: `url(${banner})`,
            backgroundSize: 'cover',
          }"
          text-variant="white"
        >
          <b-card-text style="margin-top: -1vh;">
            <div class="d-flex card-banner-content">
              <b-row class="col-12 m-0">
                <b-col cols="12" md="6" lg="8">
                  <div class="card-title text-white pt-2 pl-2 mb-2">
                    {{ $route.meta.breadcrumb[1].text }}
                  </div>
                  <p
                    v-if="$route.meta.breadcrumb[1].text == 'Communication'"
                    class="pl-2"
                  >
                    {{ this.communication }}
                  </p>
                  <p
                    v-else-if="$route.meta.breadcrumb[1].text == 'Datacomm'"
                    class="pl-2"
                  >
                    {{ this.datacomm }}
                  </p>
                  <p
                    v-else-if="$route.meta.breadcrumb[1].text == 'Internet'"
                    class="pl-2"
                  >
                    {{ this.internet }}
                  </p>
                  <p
                    v-else-if="$route.meta.breadcrumb[1].text == 'Wireless'"
                    class="pl-2"
                  >
                    {{ this.wireless }}
                  </p>
                  <p v-else class="pl-2">
                    {{ this.cyberSecurity }}
                  </p>

                  <!-- <b-button v-show="currentImageTree" class="button-product-tree ml-2" pill variant="secondary" @click="$refs['image-tree'].show()">
                    <img :src="infoIcon" style="margin-right: 1vh">Product Tree
                  </b-button>
                  <b-modal
                    ref="image-tree"
                    size="xl"
                    hide-footer
                  >
                    <div class="d-flex justify-content-center">
                      <img :src="currentImageTree" class="image-tree" alt="image-tree" />
                    </div>
                  </b-modal> -->
                  <b-button
                    v-if="$route.meta.breadcrumb[1].text === 'Wireless'"
                    class="button-product-tree ml-2 mb-2"
                    pill
                    variant="secondary"
                    @click="$refs['flipbookModal'].show()"
                  >
                    <img
                      :src="flipbookIcon"
                      style="margin-right: 1vh; width:30px"
                    />Playbook
                  </b-button>
                  <b-modal ref="flipbookModal" size="xl" hide-footer>
                    <div class="d-flex justify-content-center">
                      <iframe
                        width="100%"
                        height="900"
                        src="https://publuu.com/flip-book/673948/1552497"
                      ></iframe>
                      <!-- <img :src="currentImageTree" class="image-tree" alt="image-tree" /> -->
                    </div>
                  </b-modal>
                </b-col>
                <b-col cols="12" md="6" lg="4" class="p-0">
                  <video
                    v-show="currentVideo"
                    controls
                    preload="auto"
                    :src="currentVideo"
                    class="w-100"
                    style="border-radius: 20px;"
                  />
                </b-col>
              </b-row>
            </div>
          </b-card-text>
        </b-card>
      </b-col>
    </b-row>
    <b-row class="align-items-center">
      <b-col md="6" class="mb-2">
        <h5 class="subTit">{{ $route.meta.breadcrumb[1].text }} List</h5>
      </b-col>
      <b-col md="6" class="mb-2 d-flex justify-content-md-end align-items-center">
        <div class="search-input-wrapper mr-2">
          <feather-icon icon="SearchIcon" size="15" class="search-icon" />
          <b-form-input
            v-model="searchQuery"
            placeholder="Search product name..."
            size="sm"
            class="search-input"
          />
        </div>
        <div class="view-toggle" role="group" aria-label="Product view mode">
          <b-button
            variant="link"
            class="view-toggle-btn"
            :class="{ active: viewMode === 'grid' }"
            :pressed="viewMode === 'grid'"
            title="Grid view"
            @click="setViewMode('grid')"
          >
            <feather-icon icon="GridIcon" size="15" />
          </b-button>
          <b-button
            variant="link"
            class="view-toggle-btn"
            :class="{ active: viewMode === 'list' }"
            :pressed="viewMode === 'list'"
            title="List view"
            @click="setViewMode('list')"
          >
            <feather-icon icon="ListIcon" size="15" />
          </b-button>
        </div>
      </b-col>
    </b-row>

    <b-row>
      <b-col
        v-for="val in displayedProductArr"
        :key="val.__list_key || val.KODE"
        cols="12"
        :md="viewMode === 'grid' ? 6 : 12"
        :lg="viewMode === 'grid' ? 4 : 12"
        :xl="viewMode === 'grid' ? 3 : 12"
        :class="[
          'd-flex',
          'flex-column',
          viewMode === 'list' ? 'mb-1' : 'mb-2',
        ]"
      >
        <ProductCard
          :item="val"
          :context="$route.meta.breadcrumb[1].text"
          :view-mode="viewMode"
        />
      </b-col>
      <template v-if="loading && !displayedProductArr.length">
        <b-col
          v-for="i in 5"
          :key="'skl-' + i"
          cols="12"
          :md="viewMode === 'grid' ? 6 : 12"
          :lg="viewMode === 'grid' ? 4 : 12"
          :xl="viewMode === 'grid' ? 3 : 12"
        >
          <ProductCardSkeleton />
        </b-col>
      </template>
      <b-col v-if="!displayedProductArr.length && !loading" class="text-center">
        <b-card>
          <b-card-text>
            <h3 class="text-muted">
              No Data, please select another Product Category
            </h3>
          </b-card-text>
        </b-card>
      </b-col>
    </b-row>
    <div ref="infiniteScrollSentinel" class="infinite-scroll-sentinel" />
    <b-row v-if="loading && displayedProductArr.length" class="justify-content-center mt-1">
      <b-spinner small variant="danger" />
    </b-row>
    <b-row v-if="!hasMore && displayedProductArr.length" class="justify-content-center mt-2 mb-1">
      <span class="text-muted small">Showing all {{ displayedProductArr.length }} products</span>
    </b-row>
  </div>
</template>

<script>
import {
  BSpinner,
  BRow,
  BCol,
  BCard,
  BLink,
  BCardText,
  BCardTitle,
  BCardSubTitle,
  BDropdown,
  BDropdownItem,
  BButton,
  BModal,
  BFormInput,
} from 'bootstrap-vue'
import debounce from 'lodash/debounce'
import Ripple from 'vue-ripple-directive'
import ProductCard from '@/views/user/product/components/ProductBookmarkCard.vue'
import ProductCardSkeleton from '@/views/user/product/components/ProductCardSkeleton.vue'
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'

export default {
  components: {
    BSpinner,
    BRow,
    BCol,
    BCard,
    BLink,
    BCardText,
    BCardTitle,
    BCardSubTitle,
    BButton,
    BDropdown,
    BDropdownItem,
    BModal,
    BFormInput,
    ProductCard,
    ProductCardSkeleton,
    FeatherIcon,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      banner: require('@/assets/images/product_banner-old.png'),
      icons: ['ChevronRightIcon'],
      productArr: [],
      categories: null,
      communication: '',
      datacomm: '',
      internet: '',
      wireless: '',
      cyberSecurity: '',
      communicationAdditionalInfo: {},
      datacommAdditionalInfo: {},
      internetAdditionalInfo: {},
      wirelessAdditionalInfo: {},
      cyberSecurityAdditionalInfo: {},
      loading: false,
      currentPage: 1,
      perPage: 12,
      hasMore: true,
      searchQuery: '',
      viewMode: 'grid',
      totalRows: 0,
      isDropdown2Visible: false,
      observer: null,
      infoIcon: require('@/assets/images/icons/info.svg'),
      flipbookIcon: require('@/assets/images/icons/book.png'),
    }
  },
  computed: {
    currentImageTree() {
      if (this.$route.meta.breadcrumb[1].text == 'Communication') {
        return this.communicationAdditionalInfo.image_tree
      }
      if (this.$route.meta.breadcrumb[1].text == 'Datacomm') {
        return this.datacommAdditionalInfo.image_tree
      }
      if (this.$route.meta.breadcrumb[1].text == 'Internet') {
        return this.internetAdditionalInfo.image_tree
      }
      if (this.$route.meta.breadcrumb[1].text == 'Wireless') {
        return this.wirelessAdditionalInfo.image_tree
      }
      if (this.$route.meta.breadcrumb[1].text == 'Cyber Security') {
        return this.cyberSecurityAdditionalInfo.image_tree
      }
    },
    currentVideo() {
      if (this.$route.meta.breadcrumb[1].text == 'Communication') {
        return this.communicationAdditionalInfo.video
      }
      if (this.$route.meta.breadcrumb[1].text == 'Datacomm') {
        return this.datacommAdditionalInfo.video
      }
      if (this.$route.meta.breadcrumb[1].text == 'Internet') {
        return this.internetAdditionalInfo.video
      }
      if (this.$route.meta.breadcrumb[1].text == 'Wireless') {
        return this.wirelessAdditionalInfo.video
      }
      if (this.$route.meta.breadcrumb[1].text == 'Cyber Security') {
        return this.cyberSecurityAdditionalInfo.video
      }
    },
    displayedProductArr() {
      const normalizedRoots = (this.productArr || []).map(node =>
        this.normalizeNode(node)
      )
      return this.flattenProductTree(normalizedRoots)
    },
  },
  watch: {
    searchQuery: debounce(function() {
      this.productArr = []
      this.currentPage = 1
      this.hasMore = true
      this.fetchProduct()
    }, 400),
    $route(to, from) {
      this.productArr = []
      this.currentPage = 1
      this.totalRows = 0
      this.hasMore = true
      this.searchQuery = ''
      if (this.$route.meta.breadcrumb[1].text == 'Communication') {
        this.categories = 1
      } else if (this.$route.meta.breadcrumb[1].text == 'Datacomm') {
        this.categories = 2
      } else if (this.$route.meta.breadcrumb[1].text == 'Internet') {
        this.categories = 3
      } else if (this.$route.meta.breadcrumb[1].text == 'Wireless') {
        this.categories = 4
      } else if (this.$route.meta.breadcrumb[1].text == 'Cyber Security') {
        this.categories = 5
      }
      this.fetchProduct()
    },
  },
  created() {
    this.fetchProductLabel()
    if (this.$route.meta.breadcrumb[1].text == 'Communication') {
      this.categories = 1
    } else if (this.$route.meta.breadcrumb[1].text == 'Datacomm') {
      this.categories = 2
    } else if (this.$route.meta.breadcrumb[1].text == 'Internet') {
      this.categories = 3
    } else if (this.$route.meta.breadcrumb[1].text == 'Wireless') {
      this.categories = 4
    } else if (this.$route.meta.breadcrumb[1].text == 'Cyber Security') {
      this.categories = 5
    }
    this.fetchProduct()
  },
  mounted() {
    this.$root.$on('bv::dropdown::show', bvEvent => {
      if (bvEvent.componentId === 'dropdown-2') {
        this.isDropdown2Visible = true
      }
    })
    this.$root.$on('bv::dropdown::hide', bvEvent => {
      if (bvEvent.componentId === 'dropdown-2') {
        this.isDropdown2Visible = false
      }
      if (this.isDropdown2Visible) {
        bvEvent.preventDefault()
      }
    })
    this.observer = new IntersectionObserver(
      entries => {
        if (entries[0].isIntersecting && !this.loading && this.hasMore) {
          this.loadNextPage()
        }
      },
      { threshold: 0.1 }
    )
    if (this.$refs.infiniteScrollSentinel) {
      this.observer.observe(this.$refs.infiniteScrollSentinel)
    }
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect()
    }
  },
  methods: {
    setViewMode(mode) {
      this.viewMode = mode === 'list' ? 'list' : 'grid'
    },
    getNodeChildren(node) {
      if (!node) return []
      if (Array.isArray(node.child_details) && node.child_details.length)
        return node.child_details
      if (Array.isArray(node.CHILD) && node.CHILD.length) return node.CHILD
      return []
    },
    normalizeNode(node) {
      if (!node || typeof node !== 'object') return {}
      const children = this.getNodeChildren(node)
      const normalizedChildren = children.map(child =>
        this.normalizeNode(child)
      )
      return {
        ...node,
        child_details: normalizedChildren,
      }
    },
    flattenProductTree(nodes, depth = 0, parentKey = 'root', acc = []) {
      if (!Array.isArray(nodes) || !nodes.length) return acc
      nodes.forEach((node, index) => {
        if (!node) return
        const keySeed = node.KODE || node.PRODUCT || index
        const listKey = `${parentKey}-${depth}-${keySeed}-${index}`
        acc.push({
          ...node,
          __list_key: listKey,
        })

        const children = this.getNodeChildren(node)
        if (children.length) {
          this.flattenProductTree(
            children,
            depth + 1,
            `${parentKey}-${keySeed}-${index}`,
            acc
          )
        }
      })
      return acc
    },
    fetchProductLabel() {
      this.$http
        .get('/settings/product')
        .then(res => {
          this.communication = res.data.data.communication
          this.datacomm = res.data.data.datacomm
          this.internet = res.data.data.internet
          this.wireless = res.data.data.wireless
          this.cyberSecurity = res.data.data.cyberSecurity
          this.communicationAdditionalInfo = {
            image_tree: res.data.image_tree.communication,
            video: res.data.video.communication,
          }
          this.datacommAdditionalInfo = {
            image_tree: res.data.image_tree.datacomm,
            video: res.data.video.datacomm,
          }
          this.internetAdditionalInfo = {
            image_tree: res.data.image_tree.internet,
            video: res.data.video.internet,
          }
          this.wirelessAdditionalInfo = {
            image_tree: res.data.image_tree.wireless,
            video: res.data.video.wireless,
          }
          this.cyberSecurityAdditionalInfo = {
            image_tree: res.data.image_tree.cyberSecurity,
            video: res.data.video.cyberSecurity,
          }
        })
        .catch(err => {
          this.$notif('Error', `${err.message}`, 'error')
        })
    },
    loadNextPage() {
      if (this.loading || !this.hasMore) return
      this.fetchProduct()
    },
    fetchProduct() {
      const mapRequest = {
        map: {
          KODE: 's',
          PRODUCT: 's',
          LAST_UPDATE: 'd',
          SHORT_DESCRIPTION: 'd',
          child_details: 'd',
          PROD_CATEGORY: 'd',
          product_category_details: 'd',
          photo_product: 'd',
          is_bookmarked: 'd',
        },
      }
      const skip = (this.currentPage - 1) * this.perPage
      const take = this.perPage
      const keyword = this.searchQuery.trim()
      const searchSegment = keyword ? `/s/${encodeURIComponent(keyword)}` : ''
      this.loading = true
      this.$http
        .post(
          `/product/browse/take/${take}/skip/${skip}/category/${this.categories}/orderBy.PRODUCT/asc${searchSegment}/published/true/root/true`,
          mapRequest
        )
        .then(response => {
          const rows = response.data.data.records || []
          this.productArr = [...this.productArr, ...rows]
          if (rows.length < take) {
            this.hasMore = false
          } else {
            this.currentPage += 1
          }
          const rawTotal =
            response?.data?.data?.total ??
            response?.data?.data?.total_rows ??
            response?.data?.data?.totalData ??
            response?.data?.data?.count
          const parsedTotal = Number(rawTotal)
          if (Number.isFinite(parsedTotal) && parsedTotal >= 0) {
            this.totalRows = parsedTotal
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>

<style lang="scss">
.subTit {
  font-weight: bold;
}

.card .card-title {
  font-size: 2em;
  color: black;
}

.card-subtitle {
  font-size: 0.8em;
  color: black !important;
}

.pTurunan {
  color: black !important;
  font-weight: 500;
}
.card-banner-content {
  & > video {
    width: auto;
    max-height: 200px;
    background-color: white;
  }
}
.button-product-tree {
  background-color: white !important;
  color: black !important;
  font-weight: 600 !important;
  padding: 0.3rem 1.2rem !important;
  /* border-color: black !important; */
  box-shadow: 0px 6px 10px 0px rgba(76, 73, 65, 0),
    0px 4px 0px 0px rgba(76, 73, 65, 0.4);
  margin-top: 20px;
}
.image-tree {
  margin: 0 auto;
  max-width: 100%;
  height: auto;
}

.view-toggle {
  display: inline-flex;
  align-items: center;
  padding: 4px;
  border-radius: 999px;
  border: 1px solid rgba(15, 23, 42, 0.12);
  background: #fff;
  box-shadow: 0 6px 14px rgba(15, 23, 42, 0.08);
}

.view-toggle-btn {
  width: 32px;
  height: 32px;
  padding: 0;
  border-radius: 999px;
  color: #64748b !important;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-decoration: none !important;
}

.view-toggle-btn:hover {
  background: rgba(148, 163, 184, 0.18);
  color: #334155 !important;
}

.view-toggle-btn.active {
  background: #ef4444;
  color: #ffffff !important;
  box-shadow: 0 8px 18px rgba(239, 68, 68, 0.35);
}

.infinite-scroll-sentinel {
  height: 1px;
  width: 100%;
}

.search-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  width: 280px;

  .search-icon {
    position: absolute;
    left: 12px;
    color: #94a3b8;
    z-index: 1;
    pointer-events: none;
  }

  .search-input {
    width: 100%;
    height: 40px;
    padding-left: 36px !important;
    padding-right: 12px;
    border-radius: 999px;
    border: 1px solid rgba(15, 23, 42, 0.12);
    box-shadow: 0 2px 6px rgba(15, 23, 42, 0.04);
    font-size: 0.875rem;

    &:focus {
      border-color: #ef4444;
      box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.12);
    }
  }
}
</style>

<style lang="scss">
@import '@core/scss/vue/pages/ui-feather.scss';
</style>
